const beautifyDate = (dateString) => {
    if (!dateString) return null;
    if (typeof dateString == "string") {
        return dateString.slice(0, 4) + "." + dateString.slice(4, 6) + "." + dateString.slice(6);
    }
    return dateString;
};
export default beautifyDate;
